import React from 'react';
import { Button } from 'react-bootstrap';

const breakdown = ({ dice, dropped, total }) => {
  const kept = [...dice];
  kept.splice(kept.indexOf(dropped), 1);
  return `${kept.join(' + ')} = ${total}, dropped ${dropped}`;
};

/** Roll stats and the six numbers it gives: pick a number, then a score. A placed number goes back when clicked. */
export default function AbilityRollTray({ rolls, selected, placedStat, onRoll, onSelect, onTakeBack }) {
  return <div className="ability-roll-tray">
    <div className="ability-roll-tray__actions">
      <Button type="button" size="sm" onClick={onRoll}><i className="fa-solid fa-dice" aria-hidden="true"></i> {rolls.length ? 'Roll again' : 'Roll stats'}</Button>
      <span>{!rolls.length ? '4d6, dropping the lowest die. Or type your own scores below.' : selected ? `Choose a score for ${selected.total}.` : 'Pick a number, then a score.'}</span>
    </div>
    {rolls.length > 0 && <div className="ability-roll-tray__numbers" role="group" aria-label="Rolled numbers">
      {rolls.map((roll) => {
        const stat = placedStat(roll);
        return <button key={roll.id} type="button" title={breakdown(roll)} aria-pressed={selected?.id === roll.id}
          aria-label={stat ? `${roll.total}, placed in ${stat.toUpperCase()}. Take it back` : `${roll.total}: ${breakdown(roll)}`}
          className={`ability-roll-tray__number${selected?.id === roll.id ? ' is-selected' : ''}${stat ? ' is-placed' : ''}`} onClick={() => (stat ? onTakeBack(stat) : onSelect(roll.id))}>
          {roll.total}{stat && <small>{stat.toUpperCase()}</small>}
        </button>;
      })}
    </div>}
  </div>;
}
